<template>
<!--模拟选科页面 -->
    <div class="simulatedSubjectSelectionT">
        <common-agt-hk-window ref="commonAgHkWindow" @immediatelyArrange="immediatelyArrange"></common-agt-hk-window>
        <el-dialog
                class="ssLcJy"
                title="模拟选科实施流程建议"
                :visible.sync="dialogVisible"
                width="900px"
                :center="true"
        >
            <div>
                <p>
                    为保障学校模拟选科顺利进行，让模拟选科的统计结果能更科学地指导学校排课走班方案制定，并为后续教育教学管理提供参考。
                </p>
                <p>
                    建议学校在模拟选科实施流程中注意以下要点：
                </p>
                <h3>
                    一、模拟选科前
                </h3>
                <h4>
                    1、组建团队
                </h4>
                <p>
                    建立领导专家组，负责走班排课的统筹工作，讨论学校走班方案倾向：如是否保留行政班、自由选科还是定二走一、是否考虑成绩分层等。
                </p>
                <h4>
                    2、选科相关信息收集与分析
                </h4>
                <p>
                    盘点与选科相关的资源与信息，如学校发展特色、师资数量与分布、优劣势学科和其他需要考虑的特殊情况等
                </p>
                <h4>
                    3、学生前期生涯规划教育与选科指导
                </h4>
                <p>
                    在进行模拟选科之前，需要对高一学生开展一定的生涯规划教育，帮助学生认识自我、了解外部世界，初步树立职业大学专业梦想，并了解新高考、
                    选科的基本知识，知晓选科对自己未来的影响。 目的是让学生充分重视选科，保证模拟选科结果的准确性。
                </p>
                <h3>
                    二、模拟选科中
                </h3>
                <h4>
                    1、模拟选科参与人数保障
                </h4>
                <p>
                    学校要尽可能保证所有高一学生都参与学校模拟选科。 因为学校模拟选科人数是否符合真实高一年段学生人数，很大程度上影响了本次模拟选科统计
                    结果是否准确，同时直接影响到统计结果能否能作为未来学校排课走班的依据。
                </p>
                <h4>
                    2、模拟选科实施硬件保障
                </h4>
                <p>
                    建议统一安排机房，在老师指导下全体学生统一进行模拟选科，以保证模拟选科过程顺利进行、结果科学可信。
                </p>
                <h3>
                    三、模拟选科后
                </h3>
                <h4>
                    1、模拟选科结果研究分析
                </h4>
                <p>
                    对系统“模拟选科”统计结果进行研讨，并对学生选择与资源的差异进行统计。
                </p>
                <h4>
                    2、确定选科走班方案
                </h4>
                <p>
                    了解各走班方案优劣性分析（系统提供下载），根据学生志愿与资源现状差异调整走班方案，分析其他排课影响因素和限制条件。
                </p>
                <h4>
                    3、统整资源，为排课走班准备
                </h4>
                <p>
                    尽可能充分利用学校内外资源，包括学校课程资源、场地资源，校外企事业单位资源，充分利用资源为学校教育教学服务。
                </p>
                <h4>
                    4、走班排课
                </h4>
                <p>
                    根据方案进行排课，排课结果根据教育教学不断优化。
                </p>

            </div>
            <div slot="footer" class="border-top padding-top dialog-footer text-right">
                <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
              </div>
        </el-dialog>
        <div class="simulate-select-32Mra">
            <div class="opts-3Kt83">
                <div class="btn-2x0ER">使用指南</div>
                <div class="btn-2x0ER" @click="dialogVisible = true">模拟选科实施建议</div>
            </div>
            <div class="mode-3dIOo">
                <div class="current-xijVT" >{{titleName}}模式</div>
                <div class="switcher-2UhBm" @click="changeModel" >
                    <span class="el-icon-sort" style="transform:rotate(90deg);display: inline-block;"></span>
                    切换为{{modelName}}模式
                </div>
            </div>
            <div v-show="titleName==='3+1+2'">
                <div class="form-1rqOP">
                    <div class="item-2mYwQ">
                        <div class="key-PilUh">学科组合：</div>
                        <div class="detail-3MQMJ">
                            <div class="desc-3QGdM">请勾选以下学科组合。在 3+1+2 模式下，共有 12 种学科组合，您可以勾选全部或部分组合供学生选择。
                            </div>
                            <el-checkbox class="sel-all-aG7J8" :indeterminate="isIndeterminate"
                                         v-model="allOption312Val" @change="handleCheckAllChange">全选
                            </el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="checkedSubject312"
                                               @change="handleChecked312CitiesChange"
                                               class="subj-3jc8W">
                                <el-checkbox v-for="item in check312CheckData"
                                             :label="item.groupId" :key="item.groupId">
                                    {{item.groupName}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
                <div class="opts-1YUX-">
                    <div class="add-btn-3wFhf" @click="commitBefore('')">加入作业篮</div>
                    <div class="do-direct-a_h59" @click="commitBefore('zhi')">直接布置</div>
                </div>
            </div>
            <div v-show="titleName==='3+3'">
                <div class="form-1rqOP">
                    <div class="item-2mYwQ">
                        <div class="key-PilUh">选科模式：</div>
                        <div class="detail-3MQMJ">
                            <el-radio-group v-model="radioChangeVal" @change="changeRadio">
                                <el-radio :label="1">自由选科</el-radio>
                                <el-radio :label="2">定二走一</el-radio>
                                <el-radio :label="3">固定套餐</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="item-2mYwQ" v-show="radioChangeVal===1">
                        <div class="zydesc-3ttCP text-s-size text-small-secondary margin-medium-left">
                            提供以下学科选项：物理、化学、生物、历史、地理、政治6个学科，学生可自由选择任意三个学科作为选科组合。
                        </div>
                    </div>
                    <div class="item-2mYwQ" v-show="radioChangeVal===2">
                        <div class="key-PilUh">学科组合：</div>
                        <div class="detail-3MQMJ">
                            <div class="desc-3QGdM">
                                请勾选以下学科组合。在定二走一的模式下，先将6门学科进行两两组合，学生通过这些组合
                                确定想要学习的前两门学科，之后再从剩下的学科中挑选第三门学科。
                            </div>
                            <el-checkbox class="sel-all-aG7J8" :indeterminate="isIndeterminate21"
                                         v-model="d21AllSelectVal" @change="handleCheck21AllChange">全选
                            </el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="d2O133Group2S1Option"
                                                class="subj-3jc8W" @change="checked21Change">
                                <el-checkbox v-for="item in d2O133Group"
                                             :label="item.groupId" :key="item.groupId">{{item.groupName}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <div class="item-2mYwQ" v-show="radioChangeVal===3">
                        <div class="key-PilUh">学科组合：</div>
                        <div class="detail-3MQMJ">
                            <div class="desc-3QGdM">
                                请勾选以下学科组合。在固定套餐模式下，将6门学科进行20种排列，学生通过选择这些排列确定自己想要学习三门学科。
                            </div>
                            <el-checkbox class="sel-all-aG7J8" :indeterminate="isIndeterminateGd"
                                         v-model="gdAllCheckVal" @change="handleCheckAllChangeGd">全选
                            </el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="fixedSelectGroupData"
                                                 class="subj-3jc8W">
                                <el-checkbox v-for="item in fixed33GroupData"
                                             @change="gudCheckChange"
                                             :label="item.groupId" :key="item.groupId">
                                    {{item.groupName}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <div class="opts-1YUX-">
                        <div class="add-btn-3wFhf" @click="commitBefore('')">加入作业篮</div>
                        <div class="do-direct-a_h59" @click="commitBefore('zhi')">直接布置</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        createSelectedGroupData,
        mnSSubjectAddBasket,
        publishHomework,
        querySelectSubjectType
    } from "../../../config";
    //引入布置作业弹窗
    import commonAgtHkWindow from '../commonAgtHkWindow/commonAgtHkWindow'
    import {EventBus} from "../../../assets/static/global/event-bus";
    import {message} from 'element-ui'
    export default {
        name: "simulatedSubjectSelectionT",
        components:{
            commonAgtHkWindow
        },
        data(){
            return{
                //接收所选择的模拟选科模式
                modelId:0,
                //设置定二走一的全选值
                d21AllSelectVal:false,
                isIndeterminate:false,
                dialogVisible:false,
                modelName:'3+3',
                titleName:'3+1+2',
                optionalData:[],
                //固定组合全选的值
                gdAllCheckVal:false,
                //312的全选按钮的值
                allOption312Val:false,
                //312获取选中的值
                checkedSubject312:[],
                //获取312的多选框列表
                check312CheckData:[],
                // 获取3+3的固定组合选中的内容
                fixedSelectGroupData:[],
                //获取3+3的固定组合
                fixed33GroupData:[],
                //获取3+3的定二选一组合
                d2O133Group:[],
                //获取3+3定二选一选中的组合
                d2O133Group2S1Option:[],
                //获取3+3的自由组合
                freeGroupData:[],
                //获取3+3选中组合的值
                freeGroupDataOption:[],
                /*3+3选科内的内容切换*/
                radioChangeVal:1,
                //定二走一的全选样式
                isIndeterminate21:false,
                isIndeterminateGd:false,
                //获取布置作业之前执行接口查出的条件
                resourcesItem:''
            }
        },
        mounted(){
            this.subjectModelData();
        },
        methods:{
            //点击按钮切换3+3,3+1+2
            changeModel(){
                this.clearAllChecked();
              if(this.modelName==='3+3'){
                  this.modelName='3+1+2';
                  this.titleName='3+3';
                  this.modelId=1;
              }else{
                  this.modelName='3+3';
                  this.titleName='3+1+2';
                  this.radioChangeVal=1;
              }
            },
            //在每一次切换内容的时候清空所有多选框的选项
            clearAllChecked(){
                //固定选科
                this.gdAllCheckVal=false;
                this.fixedSelectGroupData=[];
                //定二走一选科
                this.d21AllSelectVal=false;
                this.d2O133Group2S1Option=[];

                //312选科
                this.allOption312Val=false;
                this.checkedSubject312=[];
            },
            //查出选科模式
            async subjectModelData(){
                let result=await querySelectSubjectType();
                if(result.status){
                    this.freeGroupDataOption=[];
                    this.optionalData=result.data.modelItems;
                    //312组合数据列表
                    this.check312CheckData=result.data.modelItems[3].items;
                    //固定组合列表
                    this.fixed33GroupData=result.data.modelItems[2].items;
                    //定二选一组合列表
                    this.d2O133Group=result.data.modelItems[1].items;
                    //自由选科默认将这些组合全部选中
                    result.data.modelItems[0].items.forEach((val)=>{
                        this.freeGroupDataOption.push(val.groupId)
                    })
                    // this.freeGroupDataOption=result.data.modelItems[0].items;
                }
            },
            //312全选
            handleCheckAllChange(val) {
                this.modelId=4;
                let zhi=this.check312CheckData.map(valSmall=>valSmall.groupId)
                this.checkedSubject312 = val ? zhi : [];
                this.isIndeterminate = false;
            },
            //312多选框
            handleChecked312CitiesChange(){
                this.modelId=4;
                if(this.check312CheckData.length>this.checkedSubject312.length){
                    this.allOption312Val=false;
                }else if(this.check312CheckData.length===this.checkedSubject312.length){
                    this.allOption312Val=true;
                }
            },
            //定二走一多选框
            checked21Change(){
                if(this.d2O133Group.length>this.d2O133Group2S1Option.length){
                    this.d21AllSelectVal=false;
                }else if(this.d2O133Group.length===this.d2O133Group2S1Option.length){
                    this.d21AllSelectVal=true;
                }
            },
            //固定选科多选框
            gudCheckChange(){
                 if(this.fixed33GroupData.length>this.fixedSelectGroupData.length){
                     this.gdAllCheckVal=false;
                 } else if(this.fixed33GroupData.length===this.fixedSelectGroupData.length){
                     this.gdAllCheckVal=true;
                 }
            },
            //3+3模式里面的内容切换
            changeRadio(val){
                val===1?this.modelId=1:val===2?this.modelId=2:val===3?this.modelId=3:0;
                this.clearAllChecked();
            },
            //定二走一全选方法触发
            handleCheck21AllChange(val){
                let zhi=this.d2O133Group.map(valSmall=>valSmall.groupId)
                this.d2O133Group2S1Option = val ? zhi : [];
                this.isIndeterminate21 = false;
            },
            // handleCheckedCitiesChange(){
            //
            // },
            //固定组合全选触发
            handleCheckAllChangeGd(val){
                let zhi=this.fixed33GroupData.map(valSmall=>valSmall.groupId)
                this.fixedSelectGroupData = val ? zhi : [];
                this.isIndeterminateGd = false;
            },
            //选择学科组合到临时表
            async commitBefore(val){
                let groupIds=this.modelId===1?this.freeGroupDataOption:this.modelId===2?
                    this.d2O133Group2S1Option:this.modelId===3?
                    this.fixedSelectGroupData:this.modelId===4?
                    this.checkedSubject312:[];
                // groupIds=[1,2,3,4,5,6];
                let result=await createSelectedGroupData(this.modelId,groupIds);
                if(result.status){
                    this.resourcesItem=result.data;
                    if(val===''){
                        this.addBasket(result.data);
                    }else{

                        this.$refs.commonAgHkWindow.arrangementHomework();

                    }
                }
            },
            //立即布置
            async immediatelyArrange(val){
                let result=await publishHomework(val.paperName,
                    val.isTiming,val.timeStart,val.endTime,
                    [{ categoryId:7,typeId:3,duration:this.resourcesItem.duration,
                        resourceId:this.resourcesItem.resourceId,subjectId:'8c6cd5e2785165206b48aec076fa6fc2',
                        title:this.resourcesItem.title}],
                    val.endClassData);
                if(result.status){
                    EventBus.$emit('homePickTitle','发布结果页');
                    this.$router.push('/teacher/homeworkPick/homeWorkPResultPage');
                }
            },
            //直接布置
            commitAssign(){
                this.commitBefore('zhi');
            },
            //添加到作业篮
            async addBasket(val){
                let result=await mnSSubjectAddBasket(7,'8c6cd5e2785165206b48aec076fa6fc2',
                    3,[{resourceId:val.resourceId,title:val.title,duration:val.duration}]);
                if(result.status){
                    EventBus.$emit('homeworkPick');
                    message({
                        message:'加入作业篮成功!',
                        type:'success',
                        duration:800,
                        offset:300
                    })
                }
            }
        }
    }
</script>
<style lang="scss">
    .ssLcJy{
        .el-dialog__header{
            border-bottom: 1px solid #e5e5e5;
        }
    }
</style>
<style lang="scss" scoped>
    .simulatedSubjectSelectionT{
        .simulate-select-32Mra {
            .opts-3Kt83 {
                .btn-2x0ER {
                    float: right;
                    height: 32px;
                    background: #f2f6ff;
                    border: 1px solid #5a8bff;
                    border-radius: 4px;
                    line-height: 32px;
                    padding: 0 16px;
                    margin-right: 16px;
                    color: #5a8bff;
                    user-select: none;
                    cursor: pointer;
                }
            }

            .mode-3dIOo {
                margin-top: 16px;
                overflow: hidden;

                .current-xijVT {
                    font-size: 20px;
                    font-weight: 700;
                    color: #223459;
                    line-height: 24px;
                    float: left;
                }

                .switcher-2UhBm {
                    float: left;
                    margin-left: 25px;
                    color: #5A8BFF;
                    font-size: 14px;
                    line-height: 18px;
                    margin-top: 4px;
                    cursor: pointer;
                    user-select: none;
                }
            }

            .form-1rqOP {
                margin-top: 34px;

                .item-2mYwQ {
                    margin: 0 0 26px 0;
                    display: flex;

                    .key-PilUh {
                        margin-right: 16px;
                    }
                    .key-PilUh::before {
                        content: '*';
                        color: #FF7D66;
                        margin-right: 3px;
                    }

                    .detail-3MQMJ {
                        width: 0;
                        flex: 1;
                        font-size: 14px;
                        color: #50596f;
                        line-height: 22px;
                        user-select: none;

                        .desc-3QGdM {
                            font-size: 12px;
                            color: #7c89a7;
                            line-height: 20px;
                            user-select: contain;
                        }

                        .sel-all-aG7J8 {
                            margin: 24px 0 0 0;
                        }

                        .sel-list-Oe0Nf {
                            .sel-item-2s3ys {
                                margin-top: 16px;

                                .subj-3jc8W {
                                    float: left;
                                    margin: 0 35px 12px 0;
                                }
                            }
                        }
                    }
                }
            }

            .opts-1YUX- {
                text-align: center;
                margin-top: 80px;
                margin-bottom: 165px;

                .add-btn-3wFhf, .do-direct-a_h59 {
                    display: inline-block;
                    width: 102px;
                    height: 32px;
                    margin: 0 8px;
                    border-radius: 4px;
                    line-height: 32px;
                    text-align: center;
                    cursor: pointer;
                    user-select: none;
                }

                .add-btn-3wFhf {
                    border: 1px solid currentColor;
                    color: #5a8bff;
                }

                .do-direct-a_h59 {
                    background: #5a8bff;
                    color: white;
                }
            }
        }
    }
</style>